import React, { useState } from "react";
import "../styles/AccountClosureReport.css";

export default function AccountClosureReport() {
  const [filters, setFilters] = useState({
    accountType: "",
    fromDate: "",
    toDate: "",
    accountNumber: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedBenefit, setSelectedBenefit] = useState(null);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(filters);
  };

  const openModal = (benefitData) => {
    setSelectedBenefit(benefitData);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedBenefit(null);
  };

  const mockData = [
    {
      sn: 1,
      account: "D01DD100001",
      status: "Pre Closed",
      name: "Sanny",
      guardian: "peter",
      mobile: "3216546948",
      aadhar: "897546875413",
      approvalDate: "2024-08-01",
      approvedBy: "Demo Manager",
      closureDate: "N/A",
      depositAmount: "36500.00",
      bonus: "N/A",
      closureAmount: "400.00",
      remarks: "gfbbfd",
      closedBy: "Demo Manager",
      benefitDetails: {
        accountNumber: "D01DD100001",
        closureRequest: "2024-10-11",
        closureAmount: "400.00",
        closureDate: "2024-10-11",
        bonus: "0.00",
        interestPaid: "N/A",
        otherAmount: "N/A",
        preclosureCharge: "N/A",
        branchRemarks: "gfbbfd",
      },
    },
  ];

  return (
    <div className="AccountClosureReport">
      {/* FILTER SECTION */}
      <section className="AccountClosureReport-filter-section">
        <h2>Account Report Filter</h2>
        <p>Use filter to see more precised report</p>
        <form onSubmit={handleSubmit} className="AccountClosureReport-filter-form">
          <div className="AccountClosureReport-form-group">
            <label>Choose Account Type</label>
            <select name="accountType" value={filters.accountType} onChange={handleChange}>
              <option value="">Select account type</option>
              <option value="RD">Recurring Deposit</option>
              <option value="DD">Daily Deposit</option>
              <option value="SAV">Saving Account</option>
            </select>
          </div>

          <div className="AccountClosureReport-form-group">
            <label>From Date</label>
            <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
          </div>

          <div className="AccountClosureReport-form-group">
            <label>To Date</label>
            <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
          </div>

          <div className="AccountClosureReport-form-group">
            <label>Account Number</label>
            <input type="text" name="accountNumber" value={filters.accountNumber} onChange={handleChange} placeholder="Enter account number" />
          </div>

          <button type="submit" className="AccountClosureReport-filter-button">Submit</button>
        </form>
      </section>

      {/* REPORT SECTION */}
      <section className="AccountClosureReport-report-section">
        <h2>Recurring Deposit Report</h2>
        <div className="AccountClosureReport-report-controls">
          <label>
            Search:
            <input type="text" placeholder="Search..." />
          </label>
          <label>
            Show
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            entries
          </label>
        </div>

        <div className="AccountClosureReport-table-responsive">
          <table className="AccountClosureReport-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Account</th>
                <th>Status</th>
                <th>Name</th>
                <th>Guardian</th>
                <th>Mobile</th>
                <th>Aadhar</th>
                <th>Approval Date</th>
                <th>Approved By</th>
                <th>Closure Date</th>
                <th>Deposit Amount</th>
                <th>Bonus</th>
                <th>Closure Amount</th>
                <th>Remarks</th>
                <th>Closed By</th>
                <th>Benefits</th>
              </tr>
            </thead>
            <tbody>
              {mockData.map((row, i) => (
                <tr key={i}>
                  <td>{row.sn}</td>
                  <td>{row.account}</td>
                  <td>{row.status}</td>
                  <td>{row.name}</td>
                  <td>{row.guardian}</td>
                  <td>{row.mobile}</td>
                  <td>{row.aadhar}</td>
                  <td>{row.approvalDate}</td>
                  <td>{row.approvedBy}</td>
                  <td>{row.closureDate}</td>
                  <td>{row.depositAmount}</td>
                  <td>{row.bonus}</td>
                  <td>{row.closureAmount}</td>
                  <td>{row.remarks}</td>
                  <td>{row.closedBy}</td>
                  <td>
                    <button className="benefit-btn" onClick={() => openModal(row.benefitDetails)}>Benefit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* MODAL */}
      {showModal && selectedBenefit && (
        <div className="AccountClosureReport-modal-backdrop" onClick={closeModal}>
          <div className="AccountClosureReport-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Benefit Details</h3>
            <table className="AccountClosureReport-benefit-table">
              <tbody>
                {Object.entries(selectedBenefit).map(([key, value]) => (
                  <tr key={key}>
                    <td className="key">{key.replace(/([A-Z])/g, ' $1')}</td>
                    <td className="value">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={closeModal} className="AccountClosureReport-close-btn">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
